var _defs, _line, _text, _line2, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuropea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 82,
    viewBox: "67 161 266 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .main-text {\n        font-family: 'Georgia', 'Times New Roman', serif;\n        fill: #0b5c70;\n        font-size: 34px;\n        letter-spacing: 14px;\n      }\n      .sub-text {\n        font-family: 'Georgia', 'Times New Roman', serif;\n        fill: #0b5c70;\n        font-size: 12px;\n        letter-spacing: 4px;\n      }\n      .accent {\n        stroke: #a9832f;\n        stroke-width: 2.5;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 163,
    x2: 212,
    y2: 163,
    className: "accent"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 197,
    textAnchor: "middle",
    className: "main-text"
  }, "EUROPEA")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 211,
    x2: 212,
    y2: 211,
    className: "accent"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 238,
    textAnchor: "middle",
    className: "sub-text"
  }, "LUXURY RESIDENCES")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropea);
export default __webpack_public_path__ + "static/media/europea.0109e39e15b820d06e1711a8e3ed5f5d.svg";
export { ForwardRef as ReactComponent };